export default function Contact() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Get in Touch With Me!</h1>

      <p className="mb-4">
        I’d love to hear from you! Whether you'd like to collaborate, have a question,
        or just want to connect, feel free to contact me through any of the
        platforms below!
      </p>

      <ul className="space-y-4">
        <li>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:connorchartier10@gmail.com"
            className="text-blue-500 underline"
          >
            connorchartier10@gmail.com
          </a>
        </li>
        <br />
        <li>
          <strong>LinkedIn:</strong>{" "}
          <a
            href="https://linkedin.com/in/connorchartier"
            className="text-blue-500 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            linkedin.com/in/connorchartier
          </a>
        </li>
        <br />
      </ul>
    </div>
  );
}

